import React, { PureComponent } from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import styles from './Title.scss'

export default class Title extends PureComponent {
  render() {
    const {
      children,
      mega,
      huge,
      large,
      medium,
      small,
      tiny,
      light,
      className,
      style,
      red,
      inverted,
      centered,
      centeredMobile,
      highlighted,
      shadow,
      error,
      title
    } = this.props

    const classes = cx(styles.root, {
      [styles.mega]: mega,
      [styles.huge]: huge,
      [styles.large]: large || (!medium && !small && !huge && !mega),
      [styles.medium]: medium,
      [styles.small]: small,
      [styles.tiny]: tiny,
      [styles.light]: light,
      [styles.red]: red,
      [styles.inverted]: inverted,
      [styles.centered]: centered,
      [styles.centeredMobile]: centeredMobile,
      [styles.highlighted]: highlighted,
      [styles.error]: error,
      [styles.shadow]: shadow,
      [className]: className
    })

    const Tag = (() => {
      if (tiny) {
        return 'h4'
      }

      if (small) {
        return 'h3'
      }

      if (medium) {
        return 'h2'
      }

      return 'h1'
    })()

    return (
      <Tag className={classes} style={style} title={title}>
        {children}
      </Tag>
    )
  }
}

Title.defaultProps = {
  mega: false,
  huge: false,
  large: false,
  medium: false,
  small: false,
  tiny: false,
  light: false,
  className: '',
  style: {},
  red: false,
  inverted: false,
  centered: false,
  centeredMobile: false,
  highlighted: false,
  error: false,
  title: ''
}

Title.propTypes = {
  mega: PropTypes.bool,
  huge: PropTypes.bool,
  large: PropTypes.bool,
  medium: PropTypes.bool,
  small: PropTypes.bool,
  tiny: PropTypes.bool,
  light: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.shape({}),
  red: PropTypes.bool,
  inverted: PropTypes.bool,
  centered: PropTypes.bool,
  centeredMobile: PropTypes.bool,
  highlighted: PropTypes.bool,
  shadow: PropTypes.bool,
  error: PropTypes.bool,
  title: PropTypes.string
}
